<div class="dashboard-operacao" #dashboardContainer [class.fullscreen]="fullscreenAtivo">
  <div class="dashboard-header">
    <div>
      <h1>DashBoard Operação</h1>
      <p class="subtitle">Visão operacional por grupos de estações</p>
    </div>
    <div class="header-info">
      <div class="status-chip">
        <span>Última atualização</span>
        <strong>{{ formatarDataHora(ultimaAtualizacao) }}</strong>
      </div>
      <div class="status-chip">
        <span>Próxima atualização</span>
        <strong>{{ proximaAtualizacaoSegundos }}s</strong>
      </div>
      <button type="button" class="fullscreen-btn" (click)="alternarFullscreen()">
        {{ fullscreenAtivo ? 'Sair da tela cheia' : 'Tela cheia' }}
      </button>
    </div>
  </div>

  <div class="dashboard-filtros">
    <div class="filtro small">
      <label>Data de referência</label>
      <p-datepicker [(ngModel)]="dataSelecionada" [showIcon]="true" dateFormat="dd/mm/yy" (onSelect)="atualizarFiltros()"></p-datepicker>
    </div>
    <div class="filtro large">
      <label>Agrupamento</label>
      <div class="agrupamento-grid">
        <div class="agrupamento-item">
          <p-checkbox [binary]="true" [ngModel]="agrupamentoSelecionado === 'grupo'" (onChange)="selecionarAgrupamento('grupo')"></p-checkbox>
          <span>Grupo</span>
          <div class="agrupamento-select">
            <p-dropdown [options]="gruposDisponiveis" [(ngModel)]="grupoSelecionado" [disabled]="agrupamentoSelecionado !== 'grupo'" (onChange)="atualizarFiltros()"></p-dropdown>
          </div>
        </div>
        <div class="agrupamento-item">
          <p-checkbox [binary]="true" [ngModel]="agrupamentoSelecionado === 'cliente'" (onChange)="selecionarAgrupamento('cliente')"></p-checkbox>
          <span>Cliente</span>
          <div class="agrupamento-select">
            <p-dropdown [options]="clientesDisponiveis" [(ngModel)]="clienteSelecionado" [disabled]="agrupamentoSelecionado !== 'cliente'" (onChange)="atualizarFiltros()"></p-dropdown>
          </div>
        </div>
        <div class="agrupamento-item">
          <p-checkbox [binary]="true" [ngModel]="agrupamentoSelecionado === 'coletor'" (onChange)="selecionarAgrupamento('coletor')"></p-checkbox>
          <span>Coletor</span>
          <div class="agrupamento-select">
            <p-dropdown [options]="coletoresDisponiveis" [(ngModel)]="coletorSelecionado" [disabled]="agrupamentoSelecionado !== 'coletor'" (onChange)="atualizarFiltros()"></p-dropdown>
          </div>
        </div>
        <div class="agrupamento-item">
          <p-checkbox [binary]="true" [ngModel]="agrupamentoSelecionado === 'integrador'" (onChange)="selecionarAgrupamento('integrador')"></p-checkbox>
          <span>Integrador</span>
          <div class="agrupamento-select">
            <p-dropdown [options]="integradoresDisponiveis" [(ngModel)]="integradorSelecionado" [disabled]="agrupamentoSelecionado !== 'integrador'" (onChange)="atualizarFiltros()"></p-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="filtro">
      <label>Resumo diário</label>
      <div class="chip-line">
        <div class="chip primary">
          <span>Total estações</span>
          <strong>{{ totais.totalEstacoes }}</strong>
        </div>
        <div class="chip success">
          <span>Ativas</span>
          <strong>{{ totais.ativos }}</strong>
        </div>
        <div class="chip warning">
          <span>Alertas</span>
          <strong>{{ totais.alertas }}</strong>
        </div>
        <div class="chip danger">
          <span>Offline</span>
          <strong>{{ totais.offline }}</strong>
        </div>
      </div>
    </div>
  </div>

  <div class="loading-wrapper" *ngIf="loading && !dados">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <div class="erro" *ngIf="erro">{{ erro }}</div>

  <div class="dashboard-content" *ngIf="dados">
    <div class="loading-overlay" *ngIf="loading">
      <p-progressSpinner></p-progressSpinner>
    </div>
    <div class="grid">
      <div class="card alertas">
        <div class="card-header">
          <h2>Alertas críticos</h2>
          <span class="badge">{{ dados.alertas?.length || 0 }}</span>
        </div>
        <div class="alertas-lista" *ngIf="dados.alertas?.length; else semAlertas">
          <div class="alerta-item" *ngFor="let alerta of dados.alertas">
          <div class="alerta-tag">{{ formatarStatus(alerta.tipo) }}</div>
            <div class="alerta-info">
            <strong *ngIf="alerta.estacao_nome">{{ alerta.estacao_nome }}</strong>
              <span>{{ alerta.tempo_inativo || 'Tempo não informado' }}</span>
              <small>Última atividade: {{ alerta.ultima_atividade | date: 'short' }}</small>
            </div>
          </div>
        </div>
        <ng-template #semAlertas>
          <div class="empty-state">Nenhum alerta crítico no momento.</div>
        </ng-template>
      </div>

      <div class="card grupos">
        <div class="card-header">
          <h2>Grupos de estações</h2>
          <span class="badge">{{ dados.grupos?.length || 0 }}</span>
        </div>
        <div class="grupo-item" *ngFor="let grupo of dados.grupos">
          <div class="grupo-info">
            <strong>{{ grupo.nome }}</strong>
            <span>{{ grupo.total_estacoes }} estações</span>
          </div>
          <div class="grupo-status">
            <span class="status ok">{{ grupo.ativos }} ativos</span>
            <span class="status alerta">{{ grupo.alertas }} alertas</span>
            <span class="status offline">{{ grupo.offline }} offline</span>
          </div>
          <div class="percentual">
            <div class="barra">
              <span [style.width.%]="grupo.percentual_ok"></span>
            </div>
            <small>{{ grupo.percentual_ok | number:'1.0-2' }}% OK</small>
          </div>
        </div>
      </div>
    </div>

    <div class="grid charts-grid">
      <div class="card chart-card">
        <div class="card-header">
          <h2>Mapa de calor - atividade por {{ agrupamentoSelecionado }}</h2>
          <div class="meta">
            <span>Pico: {{ dados.heatmap?.pico?.hora }}h ({{ dados.heatmap?.pico?.total }} msgs)</span>
            <span>Média/hora: {{ dados.heatmap?.media_hora | number:'1.0-0' }}</span>
          </div>
        </div>
        <div class="chart" #heatmapChart></div>
      </div>
      <div class="card chart-card">
        <div class="card-header">
          <h2>Performance por {{ agrupamentoSelecionado }} (24h)</h2>
        </div>
        <div class="chart" #performanceChart></div>
      </div>
    </div>

    <div class="grid">
      <div class="card integracoes">
        <div class="card-header">
          <h2>Integrações - status geral</h2>
        </div>
        <div class="integracao-item" *ngFor="let integracao of dados.integracoes">
          <div>
            <strong>{{ integracao.nome }}</strong>
            <span class="tipo">{{ integracao.tipo }}</span>
          </div>
          <div class="integracao-metricas">
            <div>
              <span>Sucesso</span>
              <strong>{{ integracao.taxa_sucesso | number:'1.0-2' }}%</strong>
            </div>
            <div>
              <span>Latência</span>
              <strong>{{ integracao.latencia_media_segundos }}s</strong>
            </div>
            <div>
              <span>Integrado</span>
              <strong>{{ integracao.total_integrado }}/{{ integracao.total_coletado }}</strong>
            </div>
          </div>
        </div>
      </div>

      <div class="card chart-card">
        <div class="card-header">
          <h2>Top estações - maior volume ({{ agrupamentoSelecionado }})</h2>
        </div>
        <div class="chart chart-small" #topEstacoesChart></div>
      </div>
    </div>
  </div>
</div>
